import React from "react";
import { Button, Table, DatePicker } from "antd";
import { ArrowLeftOutlined } from "@ant-design/icons";
import HistoryQCTableRow from "./HistoryTable/HistoryQCTableRow";
import HistoryQCTableCell from "./HistoryTable/HistoryQCTableCell";
import SampleInfoSection from "./SampleInfoSection";
import TestInfoTable from "./TestInfoTable";
import { HISTORY_COLUMNS } from "../../utils";
import "./HistoryView.css";

const HistoryView = ({
  rowData,
  historyInfo,
  historyLoading,
  dateRange,
  onDateRangeChange,
  onBack,
}) => (
  <div className="MarkSampleQCModal__HistoryViewContainer">
    <Button
      type="default"
      className="MarkSampleQCModal__HistoryBtn"
      icon={<ArrowLeftOutlined />}
      onClick={onBack}
    >
      Back
    </Button>
    <div className="MarkSampleQCModal__SectionWrapper">
      <SampleInfoSection rowData={rowData} />
      <TestInfoTable rowData={rowData} historyInfo={historyInfo} />
    </div>
    <div className="MarkSampleQCModal__HistoryTitleWrapper">
      <div className="MarkSampleQCModal__HistoryTitle">Sample Historical Data:</div>
      <DatePicker.RangePicker
        className="MarkSampleQCModal__HistoryDate"
        format="MM/DD/YYYY"
        value={dateRange}
        onChange={onDateRangeChange}
      />
    </div>
    <div className="MarkSampleQCModal__HistoryTableWrapper">
      <Table
        bordered
        sticky
        className="MarkSampleQCModal__HistoryTable"
        dataSource={historyInfo.samples}
        loading={historyLoading}
        pagination={false}
        scroll={{ y: "100%" }}
        components={{
          body: {
            row: HistoryQCTableRow,
            cell: HistoryQCTableCell,
          },
        }}
        onRow={(record, index) => ({ record, index })}
        columns={HISTORY_COLUMNS.map((col) => ({
          ...col,
          onCell: (record) => ({
            record,
            dataIndex: col.dataIndex,
            qcFlagKey: col.qcFlagKey,
            qcType: col.qcType,
          }),
        }))}
      />
    </div>
  </div>
);

export default HistoryView;
